module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_1_4.4d7d5185.png";